










































import { Component, Prop, Vue } from "vue-property-decorator";

import { captionForVisualization } from "./catalogHelpers";

interface VisualizationEntry {
    id: string;
    label: string;
    caption: string;
}

@Component
export default class TabExplainer extends Vue {
    /** Tab id matching the key in catalog.tabs (e.g. "hotspots", "geography"). */
    @Prop({ required: true }) tabId!: string;
    /** Full catalog payload from /roadclosureanalytics/metric_catalog. */
    @Prop({ default: null }) catalog!: any;
    /**
     * Header text shown on the collapsed expansion panel. The default fits inside a v-tab-item
     * (the explainer sits at the top of every dashboard tab). The Overview "section" above
     * the tabs overrides this to "How to read this section" since that area isn't a tab.
     */
    @Prop({ default: "How to read this tab" }) headerText!: string;

    get tab(): any {
        return this.catalog?.tabs?.[this.tabId] ?? null;
    }

    get cautions(): any[] {
        return Array.isArray(this.tab?.cautions) ? this.tab.cautions : [];
    }

    /**
     * Render a visualisation caption with the "How to read:" and "Caveat:" labels bolded.
     */
    captionHtml(caption: string): string {
        const escapeMap: Record<string, string> = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
        };
        const escaped = String(caption ?? "").replace(
            /[&<>"']/g,
            (c) => escapeMap[c],
        );
        return escaped.replace(
            /(How to read:|Caveat:)/g,
            "<strong>$1</strong>",
        );
    }

    /**
     * Visualisation entries for this tab - built from plain_language + how_to_read + caveats.
     */
    get visualizationEntries(): VisualizationEntry[] {
        const ids: string[] = Array.isArray(this.tab?.visualization_ids)
            ? this.tab.visualization_ids
            : [];
        return ids
            .map((id) => {
                const v = this.catalog?.visualizations?.[id] ?? null;
                if (!v) return null;
                return {
                    id,
                    label: v.label ?? id,
                    caption: captionForVisualization(this.catalog, id),
                };
            })
            .filter((entry): entry is VisualizationEntry => entry !== null);
    }
}
